export function getTextToDisplay(model_type, themes) {
    if (model_type && themes) {
        if (model_type.toLowerCase() === "news") {
            const theme = themes && JSON.parse(themes);
            return theme.find((t) => t.theme_type === "Section")?.theme || "";
        }
    }
    return model_type;
}
